import React from 'react';

import InstitutionListItem from './Institution';
import PersonListItem from './Person';
import PlaceListItem from './Place';
import SimpleListItem from './Simple';
import TimeslotListItem from './Timeslot';
import UserListItem from './User';
import { Link } from 'react-router-dom';

const ObjectListItem = ({ item, type, childrenId, cardView, icon, isDetailPage, path, target }) => {
    const renderItem = () => {
        switch (type) {
            case 'appointment':
                return <TimeslotListItem key={`${type}_${item.id.toString()}`} timeslot={item} />;
            case 'institution':
                return <InstitutionListItem institution={item} cardView={cardView} path={path} />;
            case 'person':
                return <PersonListItem person={item} cardView={cardView} path={path} />;
            case 'role':
                return <PersonListItem person={item} cardView={cardView} />;
            case 'place':
                return <PlaceListItem place={item} path={path} />;
            case 'timeslot':
                return path ? (
                    <li>
                        <Link
                            to={path}
                            style={{ textDecoration: 'none' }}
                            className="md-fake-btn md-pointer--hover md-fake-btn--no-outline"
                        >
                            <TimeslotListItem
                                timeslot={item}
                                childrenId={childrenId}
                                cardView={cardView}
                            />
                        </Link>
                    </li>
                ) : (
                    <TimeslotListItem timeslot={item} childrenId={childrenId} cardView={cardView} />
                );
            case 'programelement':
                return (
                    <TimeslotListItem
                        timeslot={{ ...item, type }}
                        childrenId={childrenId}
                        cardView={cardView}
                    />
                );
            case 'user':
                return <UserListItem user={item} />;
            default:
                return (
                    <SimpleListItem
                        item={item}
                        type={type}
                        classifiercolor={item.params ? item.params.color : ''}
                        icon={icon}
                        isDetailPage={isDetailPage}
                        path={path}
                        target={target}
                    />
                );
        }
    };

    return renderItem();
};

export default ObjectListItem;
